import type { RuleErrorCode } from '@halvard/rules';
import { z } from 'zod';
import type { Equals } from './types.js';

/** Error codes sent by the server. Rule errors from the engine are passed through unchanged. */
export const ERROR_CODES = [
  // From the rules engine.
  'GAME_OVER',
  'NOT_YOUR_TURN',
  'UNKNOWN_PIECE',
  'PIECE_CAPTURED',
  'PINNED',
  'ILLEGAL_ACTION',
  'BAD_NOTATION',
  'BAD_RECORD',
  // Protocol and server.
  'BAD_MESSAGE',
  'CLIENT_OUTDATED',
  'NOT_AUTHENTICATED',
  'GAME_NOT_FOUND',
  'NOT_A_PLAYER',
  'BAD_JOIN_TOKEN',
  'GAME_FULL',
  'STALE_SEQ',
  'ALREADY_IN_QUEUE',
  'NO_PENDING_OFFER',
  'RATE_LIMITED',
  'WAITING_FOR_OPPONENT',
  'INTERNAL',
] as const;

export const ErrorCodeSchema = z.enum(ERROR_CODES);
export type ErrorCode = z.infer<typeof ErrorCodeSchema>;

// Every rules engine error code must be a protocol error code.
export const ruleCodesIncluded: Equals<Extract<ErrorCode, RuleErrorCode>, RuleErrorCode> = true;
